import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgLinkedinSolid = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="-.5 -.5 16 16"
    fill="currentColor"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    {desc === undefined ? (
      <desc id={descId}>
        {"\n    Linkedin In Streamline Icon: https://streamlinehq.com\n  "}
      </desc>
    ) : desc ? (
      <desc id={descId}>{desc}</desc>
    ) : null}
    <path d="M3.4404 14.8498H.3928V5.0356h3.0476ZM1.915 3.6968C.9405 3.6969.15 2.8898.15 1.9152.15.5565 1.6208-.2927 2.7975.3866c.546.3153.8825.898.8825 1.5285 0 .9746-.7908 1.7818-1.765 1.7818m12.9317 11.153h-3.041v-4.7775c0-1.1386-.023-2.5987-1.5846-2.5987-1.5845 0-1.8273 1.237-1.8273 2.5167v4.8595H5.3495V5.0356h2.923v1.3388h.0426c.4068-.7711 1.4007-1.5849 2.8835-1.5849 3.0844 0 3.6514 2.0311 3.6514 4.6692v5.3911Z" />
  </svg>
);
export default SvgLinkedinSolid;
